/*@ngInject*/
const PolicyIssuanceActionsMediator = function (policyActionRepository) {

    this.beginIssuance = function (policyIssuanceId) {
        return policyActionRepository.beginIssuance(policyIssuanceId);
    };

    this.revertToBound = function (policyIssuanceId, reason, detail) {
        return policyActionRepository.revertToBound(policyIssuanceId, reason, detail);
    };

    this.submitForIssuance = function (policyIssuanceId) {
        return policyActionRepository.submitForIssuance(policyIssuanceId);
    };

    this.modifyIssuance = function (policyIssuanceId) {
        return policyActionRepository.modifyIssuance(policyIssuanceId);
    };

    this.markAsIssued = function (policyIssuanceId) {
        return policyActionRepository.markAsIssued(policyIssuanceId);
    };

    this.revertToPendingIssuance = function (policyIssuanceId, reason, detail) {
        return policyActionRepository.revertToPendingIssuance(policyIssuanceId, reason, detail);
    };
};

angular.module('gw-um-submission')
    .service('policyIssuanceActionsMediator', PolicyIssuanceActionsMediator);
